import {
  getFilteredData,
  getProperty,
  getUserProperty,
  postGetSlotPrice, postSellSlot, postSellSlotOtp,
  postTransferSlot,
} from '../services/userService';
import { useRef, useState } from 'react';
import {
  CoOwnData,
  GetSlotPricePayload,
  ObjectType,
  SellSlotPayload,
  TransferSlotPayload,
} from '../constant/serviceType';
import { showToast } from '../../Storeredux/constants/toastAction';

export const useProperty = ( ) => {
  const [property, setProperty] = useState<[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [priceLoading, setPriceLoading] = useState<boolean>(true);

  const [error, setError] = useState<string | null>(null);
  const [slotPrice, setSlotPrice] = useState('');
  const [paginate, setPaginate] = useState<ObjectType>({});
  const didFetch = useRef<boolean>(false);
  const getPropertyCoOwnData = async (data: CoOwnData) => {
    if (didFetch.current) return;
    let userResponse = null;
    setLoading(true);
    try {
      const response = await getProperty(data);
      console.log('PROPERTY', response);
      userResponse = response?.data?.data;
      if (userResponse) {
        setProperty(userResponse);
        setPaginate(response?.data?.pagination);
        setLoading(false);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        return { success: true };
      }
    } catch (e: any) {
      console.log(e?.response?.data?.message);
      setLoading(false);
      return { success: false, error: e?.response?.data?.message };
    }

    return userResponse;
  };
  const [others, setOthers] = useState<ObjectType>({});
  const getUserPropertyData = async (id: string | number) => {
    if (didFetch.current) return;
    let userResponse = null;
    setLoading(true);
    try {
      const response = await getUserProperty(id);
      console.log('PROPERTY', response);
      userResponse = response?.data?.data;
      if (userResponse) {
        setProperty(userResponse);
        setOthers(response?.data?.others);
        setLoading(false);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        return { success: true };
      }
    } catch (e: any) {
      console.log(e.response.data.message);
      setLoading(false);
      return { success: false, error: e.response.data.message };
    }

    return userResponse;
  };
  const getFilteredPropertyData = async (params: any) => {
    if (didFetch.current) return;
    let userResponse = null;
    setLoading(true);
    setError(null);
    try {
      const response = await getFilteredData(params);
      // console.log('PROPERTY', response);
      userResponse = response?.data?.data;
      if (userResponse) {
        setProperty(userResponse);
        setPaginate(response?.data?.pagination);
        setLoading(false);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        return { success: true };
      }
    } catch (e: any) {
      // console.log(e?.response?.data?.message);
      setLoading(false);
      setError(e?.response?.data?.message);
      return { success: false, error: e?.response?.data?.message };
    }

    return userResponse;
  };

  const transferSlot = async (payload: TransferSlotPayload) => {
    let userResponse = null;
    setLoading(true);
    setError(null);
    try {
      const response = await postTransferSlot(payload);
      // console.log('PROPERTY', response);
      userResponse = response?.data?.data;
      if (userResponse) {
        setProperty(userResponse);
        // setPaginate(response?.data?.pagination);
        setLoading(false);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        return { success: true, error: null };
      }
    } catch (e: any) {
      console.log(e?.response?.data?.message);
      showToast('Error', e.response.data.message, 'error');

      setLoading(false);
      showToast('Error', e.response.data.message, 'error');

      setError(e?.response?.data?.message);
      return { success: false, error: e?.response?.data?.message };
    }

    return userResponse;
  };

  const getSlotPrice = async (payload: GetSlotPricePayload) => {
    let userResponse = null;
    setPriceLoading(true);
    setError(null);
    try {
      const response = await postGetSlotPrice(payload);
      console.log('PROPERTY', response);
      userResponse = response?.data?.data;
      if (userResponse) {
        setPriceLoading(false);
        setSlotPrice(userResponse);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        return { success: true, data: userResponse };
      }
    } catch (e: any) {
      // console.log(e?.response?.data?.message);
      setPriceLoading(false);
      setError(e?.response?.data?.message);
      return { success: false, error: e?.response?.data?.message };
    }

    return userResponse;
  };

  const sellSlot = async (payload: SellSlotPayload) => {
    let userResponse = null;
    setLoading(true);
    setError(null);
    try {
      const response = await postSellSlot(payload);
      // console.log('PROPERTY', response);
      userResponse = response?.data?.data;
      if (userResponse) {
        setProperty(userResponse);
        setPaginate(response?.data?.pagination);
        setLoading(false);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        return { success: true };
      }
    } catch (e: any) {
      // console.log(e?.response?.data?.message);
      setLoading(false);
      setError(e?.response?.data?.message);
      showToast('Error', e.response.data.message, 'error');

      return { success: false, error: e?.response?.data?.message };
    }

    return userResponse;
  };

  const sellSlotOtp = async (payload: { user_id: string }) => {
    let userResponse = null;
    setLoading(true);
    setError(null);
    try {
      const response = await postSellSlotOtp(payload);
      console.log('PROPERTY', response);
      userResponse = response?.data?.status;
      if (userResponse) {
        showToast('Otp sent', response.data.message, 'success' );
        setLoading(false);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        return { success: true };
      }
    } catch (e: any) {
      // console.log(e?.response?.data?.message);
      setLoading(false);
      setError(e?.response?.data?.message);
      return { success: false, error: e?.response?.data?.message };
    }

    return userResponse;
  };


  return { getPropertyCoOwnData, getFilteredPropertyData, paginate, loading, property, getUserPropertyData, error, others,
    transferSlot, getSlotPrice, sellSlot,
    sellSlotOtp, slotPrice, priceLoading };
};
